import { createIdentifierStruct } from "@/modules/api/utils/jsonApiStructs";

import { unlockedTutorialsResourceType } from "./unlockedTutorialsResourceConsts";

export const unlockedTutorialItemIdentifierStruct = createIdentifierStruct(
  unlockedTutorialsResourceType
);
